import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { WorkspaceShell } from "@/features/shell/WorkspaceShell";
import { PagePending } from "@/routes/__root";

/** Pathless layout for workspace-level screens. */
export const Route = createFileRoute("/w/$workspace/_ws")({
  component: () => {
    const { workspace } = Route.useParams();
    return (
      <WorkspaceShell workspace={workspace}>
        <Suspense fallback={<PagePending />}>
          <Outlet />
        </Suspense>
      </WorkspaceShell>
    );
  },
});
